var MeterConst = /** @class */ (function () {
    function MeterConst() {
    }
    MeterConst.defaultCalibrationColor = '#333333';
    MeterConst.defaultIntegerDigits = 3;
    MeterConst.defaultFractionDigits = 0;
    MeterConst.defaultCalibrationDigitFontStyle = '12px sans-serif';
    MeterConst.defaultMasterCalibrations = 10;
    MeterConst.defaultSubCalibrations = 5;
    MeterConst.defaultCalibrationDigitColor = '#333333';
    return MeterConst;
}());
export { MeterConst };
